
import { selectCurrentProject } from './projects';
import { createSelector } from 'reselect';


export const currentProjectActiveDomainsSelector = createSelector(
  selectCurrentProject,
  (currentProject) => (currentProject.domains || []).filter(d => d.is_confirmed === true)
)



// WEBPACK FOOTER //
// ./src/reducers/selectors/domains.js